import axios from '../axios';

class Api {
    static getListUser (withselect, typeuser, bedrijf, zoekstring) {
        return axios.get(`/user/list?typeuser=${typeuser}&bedrijf=${bedrijf}&zoekstring=${zoekstring}&withselect=${withselect}`);
    }

    static getDetailUser (id) {
        return axios.get(`/user/detail/${id}`);
    }

    static getDetailMijnAccount() {
        return axios.get(`/user/detailmijnaccount`);
    }

    static isValidEmail (id, email) {
        return axios.get(`/auth/validemail?id=${id}&email=${email}`);
    }

    static addUser (payload) {
        return axios.post('/user', payload);
    }

    static mailNewPassword (email) {
        return axios.get(`/user/sendnewpassword?email=${email}`);
    }

    static updateUser (payload) {
        return axios.post(`/user/update/${payload.id}`, payload);
    }

    static updateMijnAccount (payload) {
        return axios.post(`/user/updatemijnaccount/${payload.id}`, payload);
    }

    static deleteUser (payload) {
        return axios.post(`/user/delete/${payload}`);
    }

    static updatePassword (payload) {
        return axios.post(`/user/updatepassword/${payload.id}`, payload);
    }

    static sendMail (payload) {
        return axios.post(`/user/sendmail/${payload.id}`, payload);
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/account.js